import { FC, PropsWithChildren } from 'react';
import TestIds from '../../tests/TestIds';
import Footer from '../Footer/Footer';
import Header from '../Header/Header';
import AdditionalInfo from '../AdditionalInfo/AdditionalInfo';
import styles from './Content.module.scss';

interface Props {
	name?: string;
	showBadge?: boolean;
}

const Content: FC<PropsWithChildren<Props>> = ({ children, ...restProps }) => {
	return (
		<div className={styles.container} data-cy={TestIds.Content}>
			<Header {...restProps} />
			<AdditionalInfo />
			<div className={styles.content}>{children}</div>
			<Footer />
		</div>
	);
};

export default Content;
